import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './ApiError.js';

/*
 * Marketing copy changes a few times a term, so it is cached generously; the
 * staff dashboard sets its own shorter times where freshness matters.
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        refetchOnWindowFocus: false,

        /*
         * Retrying a 401 or a 403 just burns the rate limit — the answer will
         * be the same. Only transient failures are worth a second go.
         */
        retry: (failureCount, error) => {
          if (error instanceof ApiError && !error.isRetryable) return false;
          return failureCount < 2;
        },
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
      },
      mutations: {
        // A failed mutation is the user's to retry: a silent replay of a POST
        // could create two enquiries from one click.
        retry: false,
      },
    },
  });
}
